module.exports = __webpack_public_path__ + "img/two_way_sync_no_apps_logo.ab56ed39.png";